import { Api, ApiMethod } from "../components/common/ApiLinkedButton";
import { apiLinkConstants } from "../constants";
import {
  InterviewExperience,
  InterviewExperienceResponse,
} from "../model/InterviewExperience";
import { SearchRequest } from "../model/search/UserSearchRequestV1";
import { PageResponse } from "../paging/Paging.Model";

export class InterviewExperienceAPI {
  public static fetchInterviewExperienceDetails(
    experienceId: number
  ): Api<void, InterviewExperienceResponse> {
    return new Api<void, InterviewExperienceResponse>(
      "/api/interview/experience/" + experienceId,
      ApiMethod.GET
    );
  }

  public static addInterviewExperience(
    interviewExperience: InterviewExperience
  ): Api<InterviewExperience, InterviewExperienceResponse> {
    return new Api<InterviewExperience, InterviewExperienceResponse>(
      "/api/interview/experience",
      ApiMethod.POST
    );
  }

  public static updateInterviewExperience(
    experienceId: number,
    interviewExperience: InterviewExperience
  ): Api<InterviewExperience, InterviewExperienceResponse> {
    return new Api<InterviewExperience, InterviewExperienceResponse>(
      "/api/interview/experience/" + experienceId,
      ApiMethod.PUT
    );
  }

  public static search(): Api<
    SearchRequest,
    PageResponse<InterviewExperienceResponse>
  > {
    return new Api<SearchRequest, PageResponse<InterviewExperienceResponse>>(
      "/api/interview/experiences/search",
      ApiMethod.POST
    );
  }

  public static addInterviewExperienceUsingAI(
    aiProvider: string,
    modelName: string
  ): Api<{ rawContent: string }, InterviewExperience> {
    let apiUrl = apiLinkConstants.API_INTERVIEW_EXPERIENCE_CREATE_USING_AI;
    const params = new URLSearchParams();
    params.append("aiProvider", aiProvider);
    if (modelName) {
      params.append("modelName", modelName);
    }
    apiUrl = `${apiUrl}?${params.toString()}`;
    return new Api<{ rawContent: string }, InterviewExperience>(
      apiUrl,
      ApiMethod.POST
    );
  }
}
